import { render, staticRenderFns } from "./TheWelcomeDiscountsMap.vue?vue&type=template&id=40d43c94&scoped=true&"
import script from "./TheWelcomeDiscountsMap.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeDiscountsMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d43c94",
  null
  
)

export default component.exports